// https://github.com/diegohaz/arc/wiki/Styling
import { reversePalette } from 'styled-theme/composer';

const theme = {};

theme.palette = {
  primary: ['#1976d2', '#2196f3', '#71bcf7', '#c2e2fb'],
  secondary: ['#c2185b', '#e91e63', '#f06292', '#f8bbd0'],
  danger: ['#d32f2f', '#f44336', '#f8877f', '#ffcdd2'],
  alert: ['#ffa000', '#ffc107', '#ffd761', '#ffecb3'],
  success: ['#388e3c', '#4caf50', '#7cc47f', '#c8e6c9'],
  white: ['#fff', '#fff', '#eee'],
  black: ['#000', '#333', '#666', '#999'],
  grayscale: [
    '#212121',
    '#414141',
    '#616161',
    '#9e9e9e',
    '#bdbdbd',
    '#e0e0e0',
    '#eeeeee',
    '#ffffff',
  ],
};

theme.reversePalette = reversePalette(theme.palette);

theme.fonts = {
  primary: 'Helvetica Neue, Helvetica, Roboto, sans-serif',
  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  quote: 'Georgia, serif',
};

theme.sizes = {
  maxWidth: '1440px',
};

theme.breakpoints = [
  // min-width breakpoints in ems
  40, 52, 64,
];
theme.space = [
  0, 6, 12, 18, 24, 30, 36,
];
theme.fontSizes = [
  12, 14, 18, 24, 36, 48, 72,
];
theme.weights = [
  400, 600,
];
theme.colors = {
  black: '#111',
  white: '#fff',
  blue: '#dae6f2',
};
theme.font = 'Georgia, serif';
theme.monospace = '"Roboto Mono", Menlo, monospace';
theme.radius = 0;
theme.duration = '.1s';

export default theme;



// WEBPACK FOOTER //
// ./src/components/themes/default.js